import { Box, Button, ButtonProps, ComponentWithAs } from "@chakra-ui/react";
import { forwardRef } from "react";

// Only text labels are wrapped so they can truncate; other children render as-is.
const BaseRanaButton = forwardRef<HTMLButtonElement, ButtonProps>(function RanaButton(
  { children, ...rest }: ButtonProps,
  ref
) {
  const isTextLabel = typeof children === "string" || typeof children === "number";

  return (
    <Button ref={ref} maxW="full" title={isTextLabel ? String(children) : undefined} {...rest}>
      {isTextLabel ? (
        <Box as="span" minW={0} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {children}
        </Box>
      ) : (
        children
      )}
    </Button>
  );
});

// Keeps Chakra's polymorphic `as` typing so props like `as="a"` with `href` or `as={Link}` with `to` type-check.
export const RanaButton = BaseRanaButton as ComponentWithAs<"button", ButtonProps>;
